// Component: BrandReveal.jsx
// Purpose: DS brand-reveal — the monogram "stamps in" with expanding rings + a
//   glow, once, for cold-start / first sign-in. Icon-agnostic: pass the mark via
//   the `icon` prop (an <img>, inline <svg>, or the app Logo). To replay, remount
//   with a changing `key`. Styling + animation in ds-components.css.

import React from "react";
import { cx } from "./cx";

export function BrandReveal({ icon, size = 96, loop = false, className, ...props }) {
  return (
    <span
      className={cx("ds-brand-reveal", loop && "loop", className)}
      style={{ width: size, height: size }}
      aria-hidden="true"
      {...props}
    >
      <span className="ds-br-glow" />
      <span className="ds-br-ring" />
      <span className="ds-br-ring r2" />
      <span className="ds-br-ring r3" />
      <span className="ds-br-icon">{icon}</span>
    </span>
  );
}

export default BrandReveal;
